import { Register } from '@features/ShareHolder/Register'
import { createFileRoute } from '@tanstack/react-router'
import { isUuid } from '@utils/helper-functions'
import { z } from 'zod'

const forestOwnerTypeValues = ['organization', 'private', 'shared'] as const

const shareholderRegisterSearchSchema = z.object({
  forestOwnerId: z
    .string()
    .refine((val) => !val || isUuid(val), { message: 'forestOwnerId must be a valid UUID' })
    .optional(),
  forestOwnerType: z.enum(forestOwnerTypeValues).optional(),
})

export const Route = createFileRoute('/shareholder/register')({
  component: Register,
  validateSearch: shareholderRegisterSearchSchema,
  staticData: {
    breadcrumb: 'Registrer andelseier',
  },
})
